import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'KeyboardItem',
  props: {
  keyboard: {
    type: Object,
    default: {
      key: '',
      size: {},
    },
  },
},
  emits: ["pressKey"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([`keyboard-btn`, `icon-list_${props.keyboard.key}`, `keyboard-btn_${props.keyboard.size.w || 'normal'}`]),
    style: _normalizeStyle(`${props.keyboard.style}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('pressKey', props.keyboard.key)))
  }, null, 6))
}
}

})